import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LandingPage } from "./pages/LandingPage";
import { ProfileSetup } from "./pages/ProfileSetup";
import { Dashboard } from "./pages/Dashboard";
import { AdminPanel } from "./pages/AdminPanel";

function AppRoutes() {
  const { user, userProfile, loading } = useAuth();

  console.log(
    "[APP-ROUTES] User:",
    user?.email,
    "Profile:",
    userProfile?.profile_completed,
    "Loading:",
    loading,
  );

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-vitapink-100 via-white to-gray-50 flex items-center justify-center">
        <p className="text-lg text-gray-600">Carregando...</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />

      <Route
        path="/profile-setup"
        element={
          <ProtectedRoute>
            <ProfileSetup />
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            {userProfile?.profile_completed ? (
              <Dashboard />
            ) : (
              <>
                {console.log(
                  "[APP-ROUTES] Dashboard loaded but profile not completed, redirecting to profile-setup",
                )}
                <Navigate to="/profile-setup" replace />
              </>
            )}
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        }
      />

      {/* Redirect any unknown routes to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
